import React from "react";
import "./style.css";
export default function NameValueCard(props) {
  const color = props.color || "gray";
  const { value, name, subTitle } = props;
  return (
    <div className="nameValueCard">
      <div className={`light${color} value`}>{value}</div>
      <div className={`${color} name`}>
        <div className="name-group">
          <div> {name}</div>
          {subTitle && <div> {subTitle}</div>}
        </div>
      </div>
    </div>
  );
}
